interface DataItemProps {
  left: React.ReactNode;
  middle: React.ReactNode;
  right?: React.ReactNode;
  additionalClasses?: string;
  /**
   * Additional style options for right-hand item
   *  - "Wide" - swap "middle" and "right" widths
   *  - "Narrow" - make "right" much smaller
   *  - (Default) - Normal sizing, see _DataItem.scss
   */
  rightSize?: "Wide" | "Narrow";
}

const DataItem: React.FC<DataItemProps> = ({
  left,
  middle,
  right,
  rightSize = "",
  additionalClasses = "",
}) => {
  return (
    <div className={`DataItem ${additionalClasses}`}>
      <span className="DataItemLabel">{left}</span>
      <span className="DataItemContent">{middle}</span>
      {right && (
        <span className={`DataItemAdditionalItem ${rightSize}`}>{right}</span>
      )}
    </div>
  );
};

export default DataItem;
